<template>
  <div class="row">
    <div class="col-12">
      <card class="custom-shadow-card-header card-gis-filter">
        <el-collapse v-model="activeName" @change="handleCollapse">
          <el-collapse-item :title="titleFilter" name="1">
            <div class="row p-3">
              <div class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3">
                <label>{{ $t('common_words.farm') }} *</label>
                <br />
                <el-select
                  id="farm_irrigation_forecast"
                  clearable
                  v-bind:collapse-tags="true"
                  filterable
                  class="select-primary custom-width-select required-farm shadow-sm"
                  size="large"
                  v-model="forecastForm.farm_id"
                  :placeholder="`${$t('common_words.select')}...`"
                  @change="changeData"
                >
                  <el-option
                    v-for="(option, index) in farms"
                    class="select-primary"
                    :value="option.id"
                    :label="option.name"
                    :key="index + option.id"
                  ></el-option>
                </el-select>
              </div>
              <div class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3">
                <label>{{ $t('common_words.date') }} *</label>
                <br />
                <el-date-picker
                  v-if="renderComponent"
                  id="date_irrigation_forecast"
                  class="shadow-sm required-date"
                  v-model="forecastForm.date"
                  type="date"
                  :picker-options="pickerOptions"
                  :placeholder="`${$t('common_words.select2')}...`"
                  @change="changeData"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                >
                </el-date-picker>
              </div>
              <div class="col-12 col-md-4 col-xl-2">
                <label class="label-primary" style="color: transparent">{{
                  $t('common_words.filter')
                }}</label
                ><br />
                <l-button wide type="info" class="btn-filter" @click="validate">
                  {{ $t('common_words.generate') }}
                </l-button>
              </div>
            </div>
          </el-collapse-item>
        </el-collapse>
      </card>
      <br />
      <card
        class="custom-shadow-card-header custom-table-responsive"
        v-if="irrigationForecast && reports !== null"
        :title="$t('irrigation.irrigation_forecast_report')"
      >
        <div class="mt-4">
          <div class="row" v-if="isIndex()">
            <div class="row center">
              <!-- <div class="col-sm-2 col-md-2"></div> -->
              <div class="col-sm-3 col-md-3">
                <div class="cuadrado-m gray-fondo fix_dimensions">
                  <h5 class="margin5" style="font-size: 14px">
                    {{ $t('devices.station_weather_mayus') }}
                  </h5>
                  <h5 class="margin5" style="font-size: 15px">
                    <strong>{{
                      reports['sensor_data']['station_name']
                    }}</strong>
                  </h5>
                </div>
              </div>
              <div class="col-sm-3 col-md-3 gg">
                <div class="cuadrado-m gray-fondo fix_dimensions">
                  <h5 class="margin5" style="font-size: 14px">
                    {{ $t('climate.precipitation_mayus') }}
                  </h5>
                  <h5 class="margin5" style="font-size: 14px">(mm)</h5>
                  <h5 class="margin5" style="font-size: 15px">
                    <strong>{{
                      reports['sensor_data']['precipitacion']
                    }}</strong>
                  </h5>
                </div>
              </div>
              <div class="col-sm-3 col-md-3">
                <div class="cuadrado-m gray-fondo fix_dimensions">
                  <h5 class="margin5" style="font-size: 14px">
                    {{ $t('irrigation.evapotranspiration_mayus') }}
                  </h5>
                  <h5 class="margin5" style="font-size: 14px">(mm)</h5>
                  <h5 class="margin5" style="font-size: 15px">
                    <strong>{{
                      reports['sensor_data']['ETo'] == null
                        ? 0
                        : reports['sensor_data']['ETo']
                    }}</strong>
                  </h5>
                </div>
              </div>
              <div class="col-sm-3 col-md-3">
                <div class="cuadrado-m gray-fondo fix_dimensions">
                  <h5 class="margin5" style="font-size: 14px">
                    {{ $t('irrigation.plate_apply_mayus') }}
                  </h5>
                  <h5 class="margin5" style="font-size: 14px">(mm/ha)</h5>
                  <h5 class="margin5" style="font-size: 15px">
                    <strong>{{
                      reports['sensor_data']['lamina_aplicar']
                    }}</strong>
                  </h5>
                </div>
              </div>
              <!-- <div class="col-sm-2 col-md-2"></div> -->
            </div>
            <div class="table-responsive">
              <table class="table table-striped table-bordered">
                <thead class="cusmtom-thead-color">
                  <tr>
                    <td
                      rowspan="3"
                      class="text-center p-3"
                      style="font-weight: bolder; font-size: 14px"
                    >
                      {{ $t('irrigation.engines') }}
                    </td>
                    <td
                      rowspan="3"
                      class="text-center p-3"
                      style="font-weight: bolder; font-size: 14px"
                    >
                      {{ $t('irrigation.irrigation_time') }}
                      <br />{{ $t('irrigation.hour_minute_second') }}
                    </td>
                    <td
                      rowspan="3"
                      class="text-center p-3"
                      style="font-weight: bolder; font-size: 14px"
                    >
                      {{ $t('irrigation.irrigation_time_per_block') }} <br />
                      {{ $t('irrigation.hour_minute_second') }}
                    </td>
                    <td
                      rowspan="3"
                      class="text-center p-3"
                      style="font-weight: bolder; font-size: 14px"
                    >
                      {{ $t('irrigation.irrigation_total_volume') }}
                      <br />
                      (m3)
                    </td>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(data, i) in reports.engines" :key="i">
                    <td class="text-center">{{ data.engine }}</td>
                    <td class="text-center">{{ data.tiempo_regar }}</td>
                    <td class="text-center">{{ data.tiempo_promedio }}</td>
                    <td class="text-center">{{ data.volumen_total }}</td>
                  </tr>
                  <tr>
                    <td class="text-center">
                      <b>{{ $t('common_words.mayus_totalized') }}</b>
                    </td>
                    <td class="text-center">
                      <b>{{ reports.total_tiempo_regar }}</b>
                    </td>
                    <td class="text-center">
                      <b>{{ reports.total_promedio_bloque }}</b>
                    </td>
                    <td class="text-center">
                      <b>{{ reports.total_volumen__regar }}</b>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="row" style="padding-right: 13px; padding-left: 13px">
          <div class="col-6" v-if="isPDF()">
            <div class="text-right">
              <button
                class="btn btn-danger custom-shadow-btn"
                @click="
                  exportToPDF({
                    route: `irrigation/forecast/pdf/${forecastForm.date}/${forecastForm.farm_id}`,
                    name_file: 'pronostico_riego.pdf',
                  })
                "
              >
                <em class="fa fa-file-pdf-o"></em>
                {{ $t('common_words.export_to_pdf') }}
              </button>
            </div>
          </div>
          <div class="col-6" v-if="isExcel()">
            <div class="text-left">
              <button
                class="btn custom-btn-success custom-shadow-btn"
                @click="
                  exportToExcel({
                    route: `irrigation/forecast/excel/${forecastForm.date}/${forecastForm.farm_id}`,
                    name_file: 'pronostico_riego.xlsx',
                  })
                "
              >
                <em class="fa fa-file-excel-o"></em>
                {{ $t('common_words.export_to_excel') }}
              </button>
            </div>
          </div>
        </div>
      </card>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import store from '@/store';
import { mapActions } from 'vuex';
import SweetAlert from 'src/class/Alerts';
import paginationData from './paginationData';
import mixinMasters from 'src/util/mixinMasters';
import MixinPermissions from 'src/util/mixinPermissions';
import { MixinExport } from 'src/mixins/mixin-export';
import { Pagination as LPagination } from 'src/components/index';
import { Axios } from 'src/class/Axios.js';
import MixinMenu from 'src/util/mixinMenu';
import { RadioGroup, Radio, RadioButton } from 'element-ui';

export default {
  components: {
    LPagination,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [RadioButton.name]: RadioButton,
  },

  computed: {
    titleFilter() {
      if (this.valueCollapse) {
        return this.valueCollapse.length === 1
          ? this.$i18n.t('uti.mixinFilter.hideFilters')
          : this.$i18n.t('uti.mixinFilter.showFilters');
      }

      return this.$i18n.t('uti.mixinFilter.hideFilters');
    },
  },

  data() {
    return {
      forecastForm: {
        farm_id: null,
        date: null,
      },
      activeName: '1',
      farms: [],
      valueCollapse: null,
      irrigationForecast: false,
      pagination: paginationData.pagination,
      reports: null,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
    };
  },

  mixins: [MixinPermissions, mixinMasters, MixinExport, MixinMenu],

  watch: {
    '$i18n.locale': 'forceRerender',
  },

  methods: {
    ...mapActions({
      validationInputsRequired: 'utils/validationInputsRequired',
    }),

    handleCollapse(val) {
      this.valueCollapse = val;
    },

    changeData() {
      this.irrigationForecast = false;
      this.reports = null;
    },

    validate() {
      return this.$validator.validateAll().then((response) => {
        if (!this.forecastForm.farm_id) {
          let sel = document.getElementById('farm_irrigation_forecast');
          sel.focus();
          sel.classList.add('custom-has-error');
          store.dispatch('utils/removeHasError', sel);
          return false;
        }

        if (!this.forecastForm.date) {
          let sel = document.getElementById('date_irrigation_forecast');
          sel.focus();
          sel.classList.add('custom-has-error');
          store.dispatch('utils/removeHasError', sel);
          return false;
        }

        this.irrigationForecast = true;
        this.loadForecast();
      });
    },

    loadForecast() {
      let date = new moment(this.forecastForm.date).format('YYYY-MM-DD');
      this.showHideLoading(true);
      Axios.getMasters(
        `irrigation/forecast/${date}/${this.forecastForm.farm_id}`
      )
        .then((response) => {
          this.showHideLoading();
          this.reports = response.data.data;
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    },

    exportToPDF(data) {
      this.PDF(data)
        .then(() => {
          this.showDownloadNotification();
        })
        .catch((error) => this.showMessageErrors(error));
    },

    exportToExcel(data) {
      this.Excel(data)
        .then(() => {
          this.showDownloadNotification();
        })
        .catch((error) => this.showMessageErrors(error));
    },
  },

  created() {
    Axios.getMasters('farms/farms/only')
      .then((response) => {
        this.farms = response.data.data;
      })
      .catch((error) => {
        console.log(error);
      });
  },

  mounted() {
    this.selectedItemOnMenu('irrigation');
  },

  destroyed() {
    this.deselectedItemOnMenu('irrigation');
  },
};
</script>

<style scoped>
.fix_dimensions {
  width: 110%;
  height: 100px;
}
.center {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin: auto;
  margin-bottom: 20px;
}
</style>
